﻿  /* James | Launch: match Rebuy widgets default option to the pdp selected option */
  class FormWatcher {
    constructor(options) {
      this.debug = false;
      this.widget = null;
      this.widgetID = null;
      this.apiKey = (typeof Rebuy !== 'undefined' && Rebuy.shop && Rebuy.shop.api_key) || null;
      this.formSelector = '[action="/cart/add"] [name="id"]';
      this.callback = function(){};
      this.attrMap = null;
  
      if (typeof options === 'function') {
        this.callback = options;
      }
  
      if (typeof options === 'object') {
        const keys = ['formSelector', 'callback'];
  
        for (const [key, value] of Object.entries(options)) {
          if (keys.includes(key)) {
            this[key] = value;
          }
        }
      }
  
      this.init();
      this.enableFormWatch();
    }
  
    log(...args) {
      if (this.debug === true) {
      }
    }
  
    getProductHandle(path = window.location.pathname) {
      const handles = path.match(/\/products\/([^\/]*).*$/);
      return handles ? handles[1] : null;
    }
  
    getProductJSON(handle, callback=function(){}) { 
      if (!handle) return;
      const proxyUrl = 'https://wapi.zinus.com/api/rebuy-proxy/products?limit=1&handles=' + encodeURIComponent(handle);
      const root = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
        ? String(window.Shopify.routes.root).replace(/\/?$/, '/')
        : '/';
      const shopifyProductUrl = root + 'products/' + encodeURIComponent(handle) + '.js';

      function normalizeShopifyProductOptions(p) {
        if (Array.isArray(p.options) && p.options.length && typeof p.options[0] === 'string') {
          p.options = p.options.map(function (name, i) {
            return {
              name: name,
              values: p.variants
                .map(function (v) { return v['option' + (i + 1)]; })
                .filter(function (v, idx, arr) { return v != null && arr.indexOf(v) === idx; })
            };
          });
        }
        return p;
      }

      function tryProxyProductJson() {
        fetch(proxyUrl)
          .then(function (response) {
            if (!response.ok) throw new Error();
            return response.json();
          })
          .then(function (body) {
            var list = body && body.data;
            var first = Array.isArray(list) && list.length ? list[0] : null;
            if (first) callback(first);
            else callback(null);
          })
          .catch(function () {
            callback(null);
          });
      }

      fetch(shopifyProductUrl)
        .then(function (r) {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(function (p) {
          callback(normalizeShopifyProductOptions(p));
        })
        .catch(function () {
          tryProxyProductJson();
        });
    }
  
    watchFormChange(callback=function(){}) {
      const input = document.querySelector(this.formSelector);
    
      if (input) {
          input.addEventListener('change', (event) => {
              this.log('Input changed to variant ID: ', input.value);
              callback(input.value);
          });
      }
    }
  
    getVariantByID(product, variantID) {
      if (!product || !Array.isArray(product.variants)) return null;
      return product.variants.find(variant => variant.id == variantID);
    }
    
    variantAvailable(variant) {
      return !(variant.inventory_management && variant.inventory_policy == 'deny' && variant.inventory_quantity <= 0);
    }
  
    selectVariant(product, variant) {
      this.log('selected variant', product.title, variant.title)
      product.selected_variant = variant;
      product.selected_variant_id = variant.id;
      product.option1 = variant.option1;
      product.option2 = variant.option2;
      product.option3 = variant.option3;
    }
  
    getVariantAttributeMap(product, variant) {
      const map = {};
    
      if (product && variant && Array.isArray(product.options)) {
          for (let i = 0; i < product.options.length; i++) {
              const option = product.options[i];
              const optionKey = `option${i+1}`;
              map[option.name] = [variant[optionKey]];
          }
      }
    
      return map;
    }
  
    autoSelectVariantsByAttributeMap(products, attrMap) {
      if (products && attrMap) {
        for (let i = 0; i < products.length; i++) {
            const product = products[i];
            if (!product || !Array.isArray(product.options) || !Array.isArray(product.variants)) continue;
            const productMap = {
                option1: null,
                option2: null,
                option3: null
            };
    
            for (let x = 0; x < product.options.length; x++) {
              const option = product.options[x];
              const optionKey = `option${x+1}`;
    
              if (attrMap[option.name]) {
                  this.log(attrMap[option.name], option);
                  productMap[optionKey] = option.values.filter(value => value.includes(attrMap[option.name]));
              }
            }
          
            if (Object.keys(productMap).length > 0) {
              let selectedVariant = product.variants[0];
              let selectedVariantRank = 0;
    
              for (let x = 0; x < product.variants.length; x++) {
                  const variant = product.variants[x];
                  let variantRank = 0;
                  
                  for (let o = 1; o <= 3; o++) {
                      const optionKey = `option${o}`;

                      if ((variant[optionKey] == null && productMap[optionKey] == null) || (Array.isArray(productMap[optionKey]) && productMap[optionKey].includes(variant[optionKey]))) {
                          variantRank++;
                      }
                  }
    
                  // If current variant rank is greater and it's not oos
                  if (variantRank > selectedVariantRank && this.variantAvailable(variant)) {
                    selectedVariant = variant;
                    selectedVariantRank = variantRank;
                  }
                }
    
            // Select the best matching variant
            if (selectedVariant) {
              this.selectVariant(product, selectedVariant);
            }

          }

        }
      }
    }
  
    updateWidgets() {
      if (this.widget) {
        this.autoSelectVariantsByAttributeMap(this.widget.data.products, this.attrMap);
      } else if (typeof Rebuy !== 'undefined' && Array.isArray(Rebuy.widgets)) {
        Rebuy.widgets.forEach(widget => {
          this.autoSelectVariantsByAttributeMap(widget.data.products, this.attrMap);
        });
      }
    }
  
    init() {
      const instance = this;
  
      if (typeof Rebuy !== 'undefined' && Array.isArray(Rebuy.widgets)) {
        instance.widget = Rebuy.widgets.find(widget => widget.id == instance.widgetID);
      }
      document.addEventListener('rebuy.init', function(event){
        if (event.detail.widget.id == instance.widgetID) {
          instance.widget = event.detail.widget;
        }
      });
    }
  
    enableFormWatch() {
      const instance = this;
      const handle = this.getProductHandle();
      // PDP-only helper — no product handle on collection/landing/search pages
      if (!handle) return;
    
      this.getProductJSON(handle, (product) => {
        if (!product) return;
        this.watchFormChange((variantID) => {
          this.callback(product, variantID);
        });
        // Sync immediately — covers the case where rebuy.ready already fired
        const input = document.querySelector(instance.formSelector);
        if (input) instance.callback(product, input.value);
        // Also listen for rebuy.ready in case Rebuy initialises after getProductJSON resolves
        document.addEventListener('rebuy.ready', function () {
          const input = document.querySelector(instance.formSelector);
          if (input) instance.callback(product, input.value);
        });
      });
    }
  }

  document.addEventListener('rebuy.loaded', function() { 
    const watcher = new FormWatcher(function(product, variantID) {
      if (!product) return;
      const variant = this.getVariantByID(product, variantID);
      if (!variant) return;
      this.attrMap = this.getVariantAttributeMap(product, variant);    
      this.updateWidgets();
    });
  });

  function removeTabindexFromSmartCartItems() {
    const smartcartLists = document.querySelectorAll('ul[data-smartcart-items][tabindex]');
    const rebuyLists = document.querySelectorAll('.rebuy-product-grid');
    smartcartLists.forEach((list) => {
      list.removeAttribute('tabindex');
    });
    rebuyLists.forEach((list) => {
      list.removeAttribute('tabindex');
    });
  }

  function consolidateProductLinks(context = document) {
    const productBlocks = Array.from(context.querySelectorAll('.rebuy-product-block'));

    productBlocks.forEach((productBlock) => {
      if (productBlock.hasAttribute('data-links-consolidated')) return;

      const titleHeading = productBlock.querySelector('.rebuy-product-title');
      const imageLink = productBlock.querySelector('.rebuy-product-media .rebuy-product-image');

      if (!titleHeading || !imageLink) return;

      if (imageLink.tagName === 'A') {
        const wrapper = document.createElement('div');
        wrapper.className = imageLink.className;

        const productUrl = imageLink.getAttribute('href');

        Array.from(imageLink.attributes).forEach((attr) => {
          if (attr.name === 'class' || attr.name === 'href' || attr.name === 'rel') return;
          wrapper.setAttribute(attr.name, attr.value);
        });

        if (productUrl) {
          wrapper.setAttribute('data-product-url', productUrl);

          // Accessibility
          wrapper.setAttribute('role', 'link');
          wrapper.setAttribute('tabindex', '0');

          // Mouse / touch
          wrapper.addEventListener('click', function () {
            window.location.href = productUrl;
          });

          // Keyboard
          wrapper.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        }

        while (imageLink.firstChild) {
          wrapper.appendChild(imageLink.firstChild);
        }

        imageLink.parentNode.replaceChild(wrapper, imageLink);
      }

      productBlock.setAttribute('data-links-consolidated', 'true');
    });
  }

  function insertUpdateWarningText(context = document) {
    const warningText = 'Activating this element will cause content on the page to be updated.';
    const actionContainers = Array.from(context.querySelectorAll('.rebuy-product-actions'));

    actionContainers.forEach((container) => {
      if (container.hasAttribute('data-update-warning-added')) return;

      const buttons = container.querySelectorAll('.rebuy-button');
      if (!buttons.length) return;

      const warningNode = document.createElement('p');
      warningNode.className = 'sr-only rebuy-update-warning';
      warningNode.setAttribute('aria-live', 'polite');
      warningNode.textContent = warningText;

      container.insertBefore(warningNode, buttons[0]);
      container.setAttribute('data-update-warning-added', 'true');
    });
  }

  function enhanceCarouselIndicatorDots(context = document) {
    const carousels = Array.from(context.querySelectorAll('.rebuy-product-grid'));
    
    carousels.forEach((carousel, carouselIdx) => {
      const dotsContainer = carousel.closest('.rebuy-widget')?.querySelector('.flickity-page-dots');
      if (!dotsContainer) return;
      
      const dots = Array.from(dotsContainer.querySelectorAll('.dot'));
      const carouselLabel = carousel.getAttribute('aria-label') || `Recommended products carousel ${carouselIdx + 1}`;
      
      dots.forEach((dot, dotIdx) => {
        let button = dot.querySelector('button');

        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'rebuy-carousel-dot-button';
          button.style.width = '100%';
          button.style.height = '100%';
          button.style.display = 'block';
          button.style.background = 'transparent';
          button.style.border = '0';
          button.style.padding = '0';
          button.style.cursor = 'pointer';

          while (dot.firstChild) {
            button.appendChild(dot.firstChild);
          }

          dot.appendChild(button);
        }

        dot.removeAttribute('aria-current');

        button.setAttribute('type', 'button');
        button.setAttribute('aria-label', `${carouselLabel} - Go to slide ${dotIdx + 1}`);
        button.setAttribute('aria-current', dot.classList.contains('is-selected') ? 'true' : 'false');

        if (!button.hasAttribute('data-slider-dot-initialized')) {
          button.setAttribute('data-slider-dot-initialized', 'true');
          button.addEventListener('keydown', (event) => {
            const key = event.key || event.code;
            if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
              event.preventDefault();
              button.click();
            }
          });
          button.addEventListener('click', () => {
            if (typeof dot.click === 'function') {
              dot.click();
            }
          });
        }
      });

      const updateDotsAria = () => {
        dots.forEach((dot, dotIdx) => {
          dot.removeAttribute('aria-current');
          const button = dot.querySelector('button');
          if (button) {
            button.setAttribute('aria-current', dot.classList.contains('is-selected') ? 'true' : 'false');
          }
        });
      };

      const dotsObserver = new MutationObserver(updateDotsAria);
      dots.forEach(dot => {
        dotsObserver.observe(dot, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  function enhanceRebuyCarousels(context = document) {
    const carousels = Array.from(context.querySelectorAll('.rebuy-product-grid'));
    const isCartPage = window.location.pathname === '/cart' || document.querySelector('[data-cart-page]');

    carousels.forEach((carousel, idx) => {
      // Do not mutate carousel DOM until Flickity has initialized — otherwise
      // Theme Editor / slow Secuvy release leaves a clipped non-slider row.
      if (!carousel.classList.contains('flickity-enabled')) {
        if (!carousel.hasAttribute('data-rebuy-flickity-wait')) {
          carousel.setAttribute('data-rebuy-flickity-wait', 'true');
          const flickityReadyObserver = new MutationObserver(() => {
            if (!carousel.classList.contains('flickity-enabled')) return;
            flickityReadyObserver.disconnect();
            carousel.removeAttribute('data-rebuy-flickity-wait');
            enhanceRebuyCarousels(carousel.closest('.rebuy-widget') || context);
            setTimeout(resizeRebuyFlickity, 0);
            setTimeout(resizeRebuyFlickity, 250);
          });
          flickityReadyObserver.observe(carousel, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
        return;
      }

      if (carousel.hasAttribute('data-rebuy-carousel-enhanced')) return;
      carousel.setAttribute('data-rebuy-carousel-enhanced', 'true');

      const widget = carousel.closest('.rebuy-widget');

      // Add screen-reader-only text for cart page carousels
      if (isCartPage && !carousel.hasAttribute('data-cart-carousel-sr-text-added')) {
        const existingSrText = widget && widget.querySelector('.sr-only[data-cart-carousel-description]');
        if (!existingSrText && carousel.parentNode) {
          const srText = document.createElement('p');
          srText.className = 'sr-only';
          srText.setAttribute('data-cart-carousel-description', 'true');
          srText.textContent = 'You may also like - a carousel of recommended products. Use the previous and next arrow buttons to navigate through items, or use the carousel dots below to jump to a specific product. Each product shows an image, title, price, and an add to cart button.';
          // Allyant HUB #610 / #612 / #617: the grid sits inside .rebuy-widget-content, not directly
          // in .rebuy-widget. Inserting before it on the widget threw, which aborted this function
          // after the enhanced flag was set, so the region, slide labels and hidden-slide tabindex
          // below never applied on the cart page.
          carousel.parentNode.insertBefore(srText, carousel);
        }
        carousel.setAttribute('data-cart-carousel-sr-text-added', 'true');
      }

      if (!carousel.hasAttribute('role') || carousel.getAttribute('role') === '') {
        carousel.setAttribute('role', 'region');
      }
      const existingLabel = carousel.getAttribute('aria-label');
      if (!existingLabel || !/carousel/i.test(existingLabel)) {
        // Unique per widget: name it after the widget heading when there is one.
        const headingEl = widget && widget.querySelector('.primary-title');
        const heading = headingEl ? headingEl.textContent.trim() : '';
        carousel.setAttribute('aria-label', heading ? `${heading} carousel` : `Recommended products carousel ${idx + 1}`);
      }

      const getSlides = () =>
        Array.from(carousel.querySelectorAll('.rebuy-product-block'));
      const initSlideA11y = () => {
        const slides = getSlides();
        const total = slides.length;
        slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `slide ${i + 1} of ${total}`);
        });
      };

      const updateSlideAccessibility = () => {
        const slides = getSlides();
        const total = slides.length;

        slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `slide ${i + 1} of ${total}`);

          const productTitleEl = slide.querySelector('.rebuy-product-title');
          const productName = productTitleEl ? productTitleEl.textContent.trim() : 'Product';
          const cutlineEl = slide.querySelector('.product-cutline');
          const cutlineText = cutlineEl ? cutlineEl.textContent.trim() : null;
          const images = slide.querySelectorAll('.rebuy-product-img, .rebuy-product-hover-img');
          images.forEach((img, index) => {
            let altText = productName;
            if (img.classList.contains('rebuy-product-hover-img') && cutlineText) {
              altText = `${productName} — ${cutlineText}`;
            }
            if (images.length > 1) {
              altText += ` — view ${index + 1}`;
            }
            img.setAttribute('alt', altText);
            img.setAttribute('title', altText);
          });

          const isVisible = slide.classList.contains('is-selected');
          const focusableSelectors = [
            'a[href]',
            'button',
            'input',
            'select',
            'textarea',
            '[tabindex]'
          ].join(', ');
          const focusableElements = slide.querySelectorAll(focusableSelectors);

          if (isVisible) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('tabindex');
            focusableElements.forEach((el) => {
              const original = el.getAttribute('data-rebuy-original-tabindex');
              if (original !== null) {
                if (original === 'none') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', original);
                }
                el.removeAttribute('data-rebuy-original-tabindex');
              } else if (el.tabIndex === -1 && !el.hasAttribute('tabindex')) {
                el.removeAttribute('tabindex');
              }
            });
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1');
            focusableElements.forEach((el) => {
              if (!el.hasAttribute('data-rebuy-original-tabindex')) {
                const existing = el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none';
                el.setAttribute('data-rebuy-original-tabindex', existing);
              }
              el.setAttribute('tabindex', '-1');
            });
          }
        });
      };
      let observer = new MutationObserver(() => {
        updateSlideAccessibility();
      });
      const movePrevButton = () => {
        const prevButton =
          carousel.querySelector('.flickity-button--previous') ||
          carousel.querySelector('.flickity-prev-next-button.previous') ||
          carousel.querySelector('button[aria-label="Previous"]');
        const viewport = carousel.querySelector('.flickity-viewport');

        if (prevButton && viewport && viewport.previousSibling !== prevButton) {
          observer.disconnect();
          carousel.insertBefore(prevButton, viewport);
          observer.observe(carousel, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
          });
        }
      };
      initSlideA11y();
      updateSlideAccessibility();
      observer.observe(carousel, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
      setTimeout(movePrevButton, 0);
      setTimeout(resizeRebuyFlickity, 0);
    });
    
    // Enhance carousel indicator dots
    enhanceCarouselIndicatorDots(context);

    // Consolidate duplicate product links
    consolidateProductLinks(context);
  }

  function resizeRebuyFlickity() {
    document.querySelectorAll('.rebuy-product-grid.flickity-enabled').forEach((carousel) => {
      const flkty =
        carousel.flickity ||
        (typeof Flickity !== 'undefined' && typeof Flickity.data === 'function'
          ? Flickity.data(carousel)
          : null);
      if (flkty && typeof flkty.resize === 'function') flkty.resize();
    });
  }
  
  function replaceHeadingTag(selector, newTagName) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (node.tagName.toLowerCase() === newTagName.toLowerCase()) {
          return;
        }

        var replacement = document.createElement(newTagName);
        Array.prototype.slice.call(node.attributes).forEach(function (attr) {
          replacement.setAttribute(attr.name, attr.value);
        });
        replacement.innerHTML = node.innerHTML;
        node.parentNode.replaceChild(replacement, node);
      });
  }

  function replaceNewHeadingTag(selector, newTagName) {
    document.querySelectorAll(selector).forEach(function (node) {
      if (node.tagName.toLowerCase() === newTagName.toLowerCase()) {
        wrapLink(node);
        return;
      }
      var heading = document.createElement(newTagName);
      Array.from(node.attributes).forEach(function (attr) {
        heading.setAttribute(attr.name, attr.value);
      });
      heading.innerHTML = node.innerHTML;
      node.parentNode.replaceChild(heading, node);
      wrapLink(heading);
    });
  }

  function wrapLink(heading) {
    if (heading.querySelector('a')) return;
    const href =
      heading.getAttribute("href") ||
      heading.getAttribute("data-href");
    if (!href) return;
    const text = heading.textContent.trim();
    const link = document.createElement("a");
    link.href = href;
    link.textContent = text;
    heading.innerHTML = "";
    heading.appendChild(link);
    heading.removeAttribute("href");
  }


  function replaceTotalPriceLabel(context = document) {
    const priceLabels = context.querySelectorAll('.rebuy-bundle__actions-price-label');
    priceLabels.forEach(function (node) {
      if (node.tagName.toLowerCase() === 'h3') {
        return;
      }
      const computedStyle = window.getComputedStyle(node);
      const originalFontSize = computedStyle.fontSize;
      const originalFontWeight = computedStyle.fontWeight;
      const originalLineHeight = computedStyle.lineHeight;
      const originalMargin = computedStyle.margin;      
      const replacement = document.createElement('h3');
      Array.prototype.slice.call(node.attributes).forEach(function (attr) {
        replacement.setAttribute(attr.name, attr.value);
      });
      replacement.innerHTML = node.innerHTML;
      replacement.style.fontSize = originalFontSize;
      replacement.style.fontWeight = originalFontWeight;
      replacement.style.lineHeight = originalLineHeight;
      replacement.style.margin = originalMargin;      
      node.parentNode.replaceChild(replacement, node);
    });
  }

  function handleRebuyDomUpdates(context = document) {
    removeTabindexFromSmartCartItems();
    // promoteCustomUpsellHeadings(context);
    enhanceRebuyCarousels(context);
    enhanceCarouselIndicatorDots(context);
    consolidateProductLinks(context);
    insertUpdateWarningText(context);
    replaceHeadingTag('.rebuy-widget .primary-title', 'h2');
    replaceNewHeadingTag('.rebuy-widget .rebuy-product-title', 'h3');
    replaceTotalPriceLabel(context);
    context.querySelectorAll('.rebuy-bundle__items').forEach((listEl) => {
      if (!listEl.hasAttribute('role') || listEl.getAttribute('role') === '') {
        listEl.setAttribute('role', 'list');
      }
    });
    context.querySelectorAll('.rebuy-bundle__items .rebuy-product-block').forEach((card) => {
      if (card.tagName !== 'LI') {
        card.setAttribute('role', 'listitem');
      }
      if (!card.getAttribute('aria-label')) {
        card.setAttribute('aria-label', 'product');
      }
    });
    context.querySelectorAll('.rebuy-bundle__items .rebuy-product-info').forEach((card) => {
      if (card.tagName !== 'LI') {
        card.setAttribute('role', 'group');
      }
      if (!card.getAttribute('aria-label')) {
        card.setAttribute('aria-label', 'product');
      }
    });
    document.querySelectorAll('.rebuy-widget h2.primary-title').forEach((el) => {
      el.style.fontSize = '24px';
    });
  }

  document.addEventListener('rebuy.ready', () => {
    handleRebuyDomUpdates();
    setTimeout(resizeRebuyFlickity, 0);
    setTimeout(resizeRebuyFlickity, 250);
  });
  document.addEventListener('rebuy.smartcart.open', () => {
    handleRebuyDomUpdates();
    setTimeout(() => {
      handleCartDrawerUpdates();
    }, 200);
  });
  function isMattressModalOpen() {
    const overlay = document.querySelector('.popup-overlay');
    if (overlay && overlay.classList.contains('active')) return true;
    const mulberry = document.querySelector('.mulberry-popup');
    if (mulberry && mulberry.classList.contains('active')) return true;
    const upsell = document.querySelector('.upsell-popup__wrapper');
    if (upsell && !upsell.classList.contains('hidden') && upsell.getAttribute('aria-hidden') !== 'true') return true;
    return false;
  }
  let releaseScrollLockTimer = null;
  function releaseSideCartScrollLock() {
    handleRebuyDomUpdates();
    clearTimeout(releaseScrollLockTimer);
    releaseScrollLockTimer = setTimeout(() => {
      try {
        // Leave Mulberry / upgrade popups alone — they manage their own overflow.
        if (isMattressModalOpen()) return;

        const cart = window.cart;
        if (cart && typeof cart.closeCartDrawer === 'function' && cart.isCartDrawerOpen) {
          cart.closeCartDrawer();
          return;
        }

        // Leftover class with the JS flag already false (close threw / raced).
        if (document.body.classList.contains('js-drawer-open-cart')) {
          document.body.classList.remove('js-drawer-open-cart');
          document.documentElement.removeAttribute('data-scroll-locked');
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        }
      } catch (e) {}
    }, 50);
  }
  document.addEventListener('rebuy.smartcart.close', releaseSideCartScrollLock);
  document.addEventListener('rebuy:smartcart.hide', releaseSideCartScrollLock);
  function handleCartDrawerUpdates() {
    const cartDrawer = document.querySelector('#cart-drawer') || document.querySelector('.cart-drawer');
    if (cartDrawer) {
      handleRebuyDomUpdates(cartDrawer);
      replaceHeadingTag('#cart-drawer .rebuy-widget .primary-title, .cart-drawer .rebuy-widget .primary-title', 'h2');
      replaceNewHeadingTag('#cart-drawer .rebuy-widget .rebuy-product-title, .cart-drawer .rebuy-widget .rebuy-product-title', 'h3');
    }
    const rebuyCartFlyout = document.querySelector('.rebuy-cart__flyout');
    if (rebuyCartFlyout) {
      handleRebuyDomUpdates(rebuyCartFlyout);
      replaceHeadingTag('.rebuy-cart__flyout .rebuy-widget .primary-title, .rebuy-cart__flyout .custom-upsell__wrapper .primary-title', 'h2');
      replaceNewHeadingTag('.rebuy-cart__flyout .rebuy-widget .rebuy-product-title', 'h3');
    }
  }

  let smartcartUpdateTimer = null;
  const smartcartObserver = new MutationObserver(() => {
    clearTimeout(smartcartUpdateTimer);
    smartcartUpdateTimer = setTimeout(() => {
      handleRebuyDomUpdates();
      resizeRebuyFlickity();
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', () => {
    smartcartObserver.observe(document.body, { childList: true, subtree: true });
    handleRebuyDomUpdates();
    const cartDrawer = document.querySelector('#cart-drawer') || document.querySelector('.cart-drawer');
    if (cartDrawer) {
      const cartDrawerObserver = new MutationObserver(() => {
        handleCartDrawerUpdates();
      });
      cartDrawerObserver.observe(cartDrawer, { childList: true, subtree: true });
      const cartDrawerToggles = document.querySelectorAll('[data-cart-drawer-toggle]');
      cartDrawerToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          setTimeout(() => {
            handleCartDrawerUpdates();
          }, 100);
        });
      });
    }
    const rebuyCartFlyout = document.querySelector('.rebuy-cart__flyout');
    if (rebuyCartFlyout) {
      const rebuyCartObserver = new MutationObserver(() => {
        handleCartDrawerUpdates();
      });
      rebuyCartObserver.observe(rebuyCartFlyout, { childList: true, subtree: true });
    }
    const rebuyCartFlyoutObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('rebuy-cart__flyout')) {
              handleCartDrawerUpdates();
              const observer = new MutationObserver(() => {
                handleCartDrawerUpdates();
              });
              observer.observe(node, { childList: true, subtree: true });
            }
            const flyout = node.querySelector && node.querySelector('.rebuy-cart__flyout');
            if (flyout) {
              handleCartDrawerUpdates();
            }
          }
        });
      });
    });
    rebuyCartFlyoutObserver.observe(document.body, { childList: true, subtree: true });
    const body = document.body;
    if (body) {
      const cartDrawerOpenObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('js-drawer-open-cart')) {
              setTimeout(() => {
                handleCartDrawerUpdates();
              }, 200);
            }
          }
        });
      });
      cartDrawerOpenObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
    }
  });
